import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { FORM_ACTION } from "../../../../../core/router/types/routerTypes";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormMutation } from "../../../../../core/service/types/FormMutation";
import type { FormQuery } from "../../../../../core/service/types/FormQuery";
import type { Dto } from "../../../../../core/types/be/Dto";
import type { ProductCopyEntity } from "../../types/ProductCopyEntity";
import type { ProductEntity } from "../../types/ProductEntity";
import { ProductCopyEntityToCopyDto } from "../mappers/ProductCopyEntityToCopyDto";
import { ProductDtoToEntity } from "../mappers/ProductDtoToEntity";
import { ProductEntityToDto } from "../mappers/ProductEntityToDto";

const ProductApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        ProductLoad: builder.query<ProductEntity, FormQuery>({
            providesTags: [ResourceName.PRODUCTS],
            query: (queryParams) => {
                const dataGroup = getAssignedDataGroup();
                return {
                    url: `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.PRODUCTS}/${queryParams.entityId}`,
                    method: "GET",
                };
            },
            transformResponse: (response: Dto, _) => {
                return ProductDtoToEntity(response);
            },
        }),
        ProductSave: builder.mutation<ProductEntity, FormMutation<ProductEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.PRODUCTS}`;
                const method = "POST";

                const body = ProductEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.PRODUCTS],
        }),
        ProductUpdate: builder.mutation<ProductEntity, FormMutation<ProductEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.PRODUCTS}/${mutation.data.id}`;
                const method = "PUT";

                const body = ProductEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.PRODUCTS],
        }),
        ProductCopy: builder.mutation<ProductEntity, FormMutation<ProductCopyEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.PRODUCTS}/${mutation.data.id}/${FORM_ACTION.COPY}`;
                const method = "POST";

                const body = ProductCopyEntityToCopyDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.PRODUCTS],
        }),
    }),
});

export const { useProductLoadQuery, useProductSaveMutation, useProductUpdateMutation, useProductCopyMutation } = ProductApi;
